(() => {
  if (window.__proHeadspaAttributionV2) return;
  window.__proHeadspaAttributionV2 = true;
  document.documentElement.dataset.proheadspaTracking = 'ready';

  const ROUTER = 'proheadspa-contact-routing.steep-king-f559.workers.dev';
  const STORAGE = 'proheadspa:attribution:v2';
  const OLD_STORAGE = 'proheadspa:attribution:v1';
  const MAX_AGE = 12 * 60 * 60 * 1000;
  const GREETINGS = {
    fr: 'Bonjour, je souhaite échanger avec Pro Headspa au sujet de mon projet.',
    en: 'Hello, I would like to discuss my project with Pro Headspa.',
    de: 'Guten Tag, ich möchte mein Projekt mit Pro Headspa besprechen.',
    es: 'Hola, me gustaría hablar con Pro Headspa sobre mi proyecto.',
    it: 'Buongiorno, vorrei parlare del mio progetto con Pro Headspa.',
    pt: 'Olá, gostaria de falar com a Pro Headspa sobre o meu projeto.',
    nl: 'Hallo, ik wil mijn project graag met Pro Headspa bespreken.',
    ja: 'こんにちは。Pro Headspaにプロジェクトについて相談したいです。',
    zh: '您好，我想向 Pro Headspa 咨询我的项目。',
  };
  const KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_source_platform', 'campaign_id', 'adset_id', 'ad_id', 'placement', 'site', 'market'];
  const CAMPAIGN_KEYS = KEYS.slice(0, 10);
  const originalLinks = new WeakMap();
  let memory = null;
  let lastArrival = '';
  let privacyLoading = false;

  function permitted(purpose) {
    const privacy = window.Shopify?.customerPrivacy;
    const method = purpose === 'marketing' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
    try { return typeof privacy?.[method] === 'function' && privacy[method]() === true; }
    catch (_) { return false; }
  }

  function clean(value) {
    if (typeof value !== 'string' || /\{\{|\}\}|@/.test(value)) return '';
    return value.replace(/[\u0000-\u001f\u007f<>]/g, ' ').trim().slice(0, 256);
  }

  function validValues(values) {
    const result = {};
    if (!values || typeof values !== 'object') return result;
    KEYS.forEach(key => { const value = clean(values[key]); if (value) result[key] = value; });
    return result;
  }

  function clearStorage() {
    memory = null;
    lastArrival = '';
    try { window.sessionStorage.removeItem(STORAGE); window.sessionStorage.removeItem(OLD_STORAGE); }
    catch (_) { /* Browsing and contacting the team work without storage. */ }
  }

  function readAttribution() {
    if (!permitted('marketing')) return null;
    let record = memory;
    let legacy = false;
    try {
      if (!record) {
        const current = window.sessionStorage.getItem(STORAGE);
        const previous = !current && window.sessionStorage.getItem(OLD_STORAGE);
        record = JSON.parse(current || previous || 'null');
        legacy = Boolean(previous);
      }
    } catch (_) { /* Use this page's in-memory attribution if storage is blocked. */ }
    const age = record && Date.now() - record.createdAt;
    if (!record || !Number.isFinite(age) || age < 0 || age > MAX_AGE) return null;
    const values = validValues(record.values);
    if (!CAMPAIGN_KEYS.some(key => values[key])) return null;
    if (legacy) {
      memory = { createdAt: record.createdAt, values };
      try { window.sessionStorage.setItem(STORAGE, JSON.stringify(memory)); window.sessionStorage.removeItem(OLD_STORAGE); }
      catch (_) { /* Keep the previous campaign in memory if storage is blocked. */ }
    }
    return values;
  }

  function captureArrival() {
    if (!permitted('marketing') || lastArrival === window.location.href) return;
    lastArrival = window.location.href;
    const params = new URL(lastArrival).searchParams;
    const values = {};
    KEYS.forEach(key => { const value = clean(params.get(key)); if (value) values[key] = value; });
    if (!CAMPAIGN_KEYS.some(key => values[key])) return;
    memory = { createdAt: Date.now(), values };
    try { window.sessionStorage.setItem(STORAGE, JSON.stringify(memory)); }
    catch (_) { /* Same-page forwarding still works. */ }
  }

  function originalHref(link) {
    const href = link.getAttribute('href');
    let record = originalLinks.get(link);
    if (!record || (href !== record.rendered && href !== record.base)) {
      record = { base: href, rendered: href };
      originalLinks.set(link, record);
    }
    return record;
  }

  function reference(values) {
    return [values.utm_source, values.utm_campaign || values.utm_id, values.ad_id || values.utm_content].filter(Boolean).join(' · ');
  }

  function decorate(link, values) {
    if (!link?.getAttribute || !link.getAttribute('href')) return;
    const record = originalHref(link);
    let url;
    try { url = new URL(record.base, window.location.href); } catch (_) { return; }
    if (!['http:', 'https:'].includes(url.protocol)) return;
    const isCal = ['cal.com', 'www.cal.com', 'app.cal.com'].includes(url.hostname);
    const isWhatsApp = ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname);
    const isRouter = url.hostname === ROUTER && url.pathname === '/whatsapp';
    const isContact = url.origin === window.location.origin && /\/pages\/contact(?:-us)?\/?$/.test(url.pathname);
    if (!isCal && !isWhatsApp && !isRouter && !isContact) return;

    if (values) {
      if (isWhatsApp) {
        const language = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
        const prefix = url.searchParams.get('text') || GREETINGS[language] || GREETINGS.en;
        const ref = reference(values);
        if (ref) url.searchParams.set('text', prefix + '\n\nRef.: ' + ref);
      } else {
        // Start from the original link every time: never duplicate or mix campaign tags.
        KEYS.forEach(key => url.searchParams.delete(key));
        KEYS.forEach(key => { if (values[key]) url.searchParams.set(key, values[key]); });
      }
      record.rendered = url.href;
    } else {
      record.rendered = record.base;
    }
    if (link.getAttribute('href') !== record.rendered) link.setAttribute('href', record.rendered);
  }

  function decorateForms(values) {
    document.querySelectorAll('form[action*="/contact"], form[id*="ContactForm"]').forEach(form => {
      KEYS.forEach(key => {
        let input = form.querySelector('input[data-ph-attribution="' + key + '"]');
        if (!values?.[key]) { input?.remove(); return; }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'contact[' + key + ']';
          input.dataset.phAttribution = key;
          form.appendChild(input);
        }
        input.value = values[key];
      });
    });
  }

  function refresh() {
    if (!permitted('marketing')) clearStorage();
    captureArrival();
    const values = readAttribution();
    document.querySelectorAll('a[href]').forEach(link => decorate(link, values));
    decorateForms(values);
  }

  function linkFrom(event) {
    return (typeof event.composedPath === 'function' ? event.composedPath() : [])
      .find(node => node instanceof Element && node.matches('a[href]')) || event.target?.closest?.('a[href]');
  }

  function contactMethod(element) {
    const href = element.getAttribute('href') || '';
    if (href.startsWith('tel:')) return 'phone';
    if (href.startsWith('mailto:')) return 'email';
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return null; }
    if (['cal.com', 'www.cal.com', 'app.cal.com'].includes(url.hostname)) return 'appointment';
    if (['wa.me', 'api.whatsapp.com', 'web.whatsapp.com', ROUTER].includes(url.hostname)) return 'whatsapp';
    return null;
  }

  function pushContact(element, method) {
    if (!permitted('marketing') && !permitted('analytics')) return;
    const pageType = Array.from(document.body.classList).find(value => value.startsWith('template-'));
    const values = readAttribution();
    const payload = Object.assign({
      contact_method: method,
      contact_label: (element.textContent || element.getAttribute('aria-label') || '').trim().slice(0, 120),
      page_type: pageType ? pageType.replace('template-', '') : 'unknown',
      page_path: window.location.pathname,
      page_language: document.documentElement.lang || 'fr',
    }, values || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'contact' }, payload));
    document.documentElement.dataset.lastContactEvent = method;
    if (typeof window.Shopify?.analytics?.publish === 'function') window.Shopify.analytics.publish('contact', payload);
  }

  function beforeNavigation(event) {
    captureArrival();
    decorate(linkFrom(event), readAttribution());
  }
  ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin'].forEach(name => document.addEventListener(name, beforeNavigation, true));
  document.addEventListener('click', event => {
    const element = linkFrom(event);
    if (!element) return;
    const method = contactMethod(element);
    if (method) pushContact(element, method);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/contact"], form[id*="ContactForm"]')) {
      refresh();
      pushContact(event.target, 'form');
    }
  });
  ['page:loaded', 'shopify:section:load', 'visitorConsentCollected'].forEach(name => document.addEventListener(name, refresh));
  ['popstate', 'pageshow'].forEach(name => window.addEventListener(name, refresh));

  function initialize() {
    // Shopify's API applies the store's own region and consent settings.
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function' && !privacyLoading) {
      privacyLoading = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => refresh());
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
